import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import '@/styles/index.scss'
import '@/assets/icon/iconfont.css'

import utils from '@/utils/common'
import apis from '@/apis'
import constants from '@/constants'
import eventBus from '@/utils/eventBus'
import '@/components'
import '@/utils/flexible'

Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperty(Vue.prototype, '$utils', { value: utils })
Object.defineProperty(Vue.prototype, '$apis', { value: apis })
Object.defineProperty(Vue.prototype, '$constants', { value: constants })
Object.defineProperty(Vue.prototype, '$eventBus', { value: eventBus })

const isProduction = process.env.NODE_ENV === 'production'

// 设置 baseURL
axios.setConfig = function(config) {
  axios.defaults.baseURL = config.BASE_URL
  axios.defaults.timeout = config.AJAX_TIMEOUT
}

//处理过滤器
import filters from './filter'
for (var i in filters) {
  Vue.filter(i, filters[i])
}

Vue.config.productionTip = false
const globalFilePath = isProduction ? 'static/global-config.json' : 'static/global-config-dev.json'
axios.get(globalFilePath).then(res => {
  document.title = '崂山链底座管理系统'
  window.ajaxBaseUrl = res.data['BASE_URL']
  Vue.use(ElementUI, { size: 'medium' })
  Vue.prototype.g_Config = res.data
  axios.setConfig(Vue.prototype.g_Config)
  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
